import React, {Component} from 'react';
import { Nav,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import news_banner from '../img/news_banner.jpg'
import map from '../img/map.jpg'
import erwm from '../img/erwm.png'
import './all.css'


class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={news_banner} />
                </Row>
                <Row className="justify-content-md-center text-center" >
                    <Col xs={12} lg={8}>
                        <Nav className="justify-content-center about_nav" activeKey="/contact">
                            {/* <Nav.Item>
                                <Nav.Link href="/aboutService">全球服务网络</Nav.Link>
                            </Nav.Item> */}
                            <Nav.Item>
                                <Nav.Link href="/aboutIntroduce">润脉技术介绍</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="/contact">联系我们</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                </Row>
                <Row className="justify-content-md-center text-center">
                    <Col lg={8} >
                            <div style={{marginTop:'5%'}}>
                                无论您是对润脉有宝贵意见，还是想与润脉合作共赢；无论您是想成为润脉咨询师，还是想加入
                                润脉团队，都欢迎通过以下方式联系我们，感谢您对润脉的关注和关爱！
                            </div>
                            <div style={{margin:'4% 0'}}>润脉（raymedychina.com）北京润脉科技有限公司</div>
                            <img src={erwm}  className="d-block w-25" className={{margin:'auto'}}/>
                            <div style={{marginTop:'4%'}}>联系电话：400-1022771</div>
                            <div>邮箱：info@raymedy-china.com</div>
                            <div style={{marginBottom:'4%'}}>地址：北京市密云区兴云路98号3幢108</div>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default Contact;

